import { useOnboardingContext } from '@frontend/web/context/OnboardingContext';
import { StoriesSlides } from '../Stories/StoriesSlides';

export const Stories = () => {
  const { incrementStep } = useOnboardingContext();

  return <StoriesSlides onComplete={incrementStep} />;
};
